export default function capitalize(incomingString: string): string {
  if (typeof incomingString !== 'string') return ''
  return incomingString.charAt(0).toUpperCase() + incomingString.slice(1);
}
